var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.sassStyles.root},[_c('img',{class:_vm.sassStyles.icon,attrs:{"src":_vm.noResults.icon,"width":"50","height":"50"}}),_c('p',{class:_vm.sassStyles.text,domProps:{"innerHTML":_vm._s(_vm.noResults.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }